import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_x9g88vqesu: FaireBrandEntity = {
  token: "b_x9g88vqesu",
  type: "brand",
  name: "Phyzzy",
  avatarUrl:
    "https://cdn.faire.com/fastly/0ef357dd585b472df0450b28e8481e8149d0cfc2c1607b952dc33954c15525f5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2481e1978f395aba3659cef8b99ad2b8526007d30756497f04dcfee288d224f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0ef357dd585b472df0450b28e8481e8149d0cfc2c1607b952dc33954c15525f5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2481e1978f395aba3659cef8b99ad2b8526007d30756497f04dcfee288d224f0.jpeg",
  location: "NDIP, QC, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 14,
  isInsider: false,
  description:
    "At Phyzzy, we are committed to making a meaningful impact on our planet while delivering exceptional products and services. Our core belief in sustainability drives us to minimize our environmental footprint, and one of the tangible ways we manifest this commitment is by avoiding excessive packaging.\n\nIn addition to our unwavering dedication to sustainability, we specialize in providing white-label products tailored to meet your precise branding requirements. Our white-label solutions offer you the flexibility to customize and brand our products with your unique logo, design, and packaging, allowing you to craft a distinct and personalized offering for your valued customers. With our range of high-quality products and an unwavering commitment to excellence, we empower your brand to shine brightly in the market. \n\nTogether, we can create a positive impact, not only for your brand but also for the environment, demonstrating that business and sustainability can harmoniously coexist\n\nPlease use Direct link to order ---> https://faire.com/direct/phyzzy",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:06.836Z",
    importedBy: "entity-db-cli",
  },
};
